import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// ng-zorro modules
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';

// Components
import { SaveQueryDialogComponent } from './save-query-dialog/save-query-dialog.component';
import { RenameQueryDialogComponent } from './rename-query-dialog/rename-query-dialog.component';
import { ManageQueriesDialogComponent } from './manage-queries-dialog/manage-queries-dialog.component';
import { SavedSearchButtonsComponent } from './saved-search-buttons/saved-search-buttons.component';

const DIALOG_COMPONENTS = [
  SaveQueryDialogComponent,
  RenameQueryDialogComponent,
  ManageQueriesDialogComponent,
  SavedSearchButtonsComponent
];

const NZ_MODULES = [
  NzModalModule,
  NzFormModule,
  NzInputModule,
  NzButtonModule,
  NzCheckboxModule,
  NzTableModule,
  NzRadioModule,
  NzDropDownModule,
  NzMenuModule,
  NzIconModule,
  NzTagModule,
  NzSpinModule,
  NzEmptyModule,
  NzMessageModule,
  NzToolTipModule,
  NzSelectModule,
  NzPaginationModule
];

@NgModule({
  declarations: [...DIALOG_COMPONENTS],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...NZ_MODULES
  ],
  exports: [...DIALOG_COMPONENTS]
})
export class SavedSearchModule {}
